import router from '@/router'
import { useFormStore } from '@/stores/form'

export default function () {
  const formStore = useFormStore()
  const res = {
    administrativeRegionId: formStore.extraMap.administrativeRegionId,
    establishmentRequestTypeId: formStore.form.values.establishmentRequestTypeId,
    establishmentRequestActionTypeId: formStore.form.values.establishmentRequestActionTypeId,
    isUsingCardReader: formStore.form.values.isUsingCardReader,
    immigrationDepartmentId: formStore.form.values.immigrationDepartmentId,
    establishmentPartnershipTypeId: formStore.form.values.establishmentPartnershipTypeId,
    establishmentAgentTypeId: formStore.form.values.establishmentAgentTypeId,
    immigrationDepartmentId: formStore.form.values.immigrationDepartmentId,
    isNocRequest: formStore.extraMap.isNocRequest,
    isConcernedEstablishmentAvailable: formStore.extraMap.isConcernedEstablishmentAvailable
  }
  return res
}
